import { useEffect } from 'react';
import './App.css';
import Navbar from './Navbar';
import Home from './Home';
import AboutUs from './AboutUs';
import OurServices from './OurServices';
import WhyChoose from './WhyChoose';
import Achievements from './Achievements';
import HowItWorks from './HowItWorks';
import ExploreWork from './ExploreWork';
import ContactUs from './ContactUs';
import MapView from './MapView';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
    useEffect(() => {
      AOS.init({
        duration: 1000,     // animation duration in ms
        once: true,         // only animate once per scroll
        offset: 100,        // trigger offset (px before element enters view)
      });
    }, []);
  return (
    <div className="h-screen scroll-smooth">
      <Navbar />
      <section className="scroll-mt-[90px]" id="home"><Home /></section>
      <section className="scroll-mt-[90px]" id="about"><AboutUs /></section>
      <section className="scroll-mt-[90px]" id="services"><OurServices /></section>
      <section className="scroll-mt-[90px]" id="why"><WhyChoose /></section>
      <section className="scroll-mt-[90px]" id="achievements"><Achievements /></section>
      <section className="scroll-mt-[90px]" id="how"><HowItWorks /></section>
      <section className="scroll-mt-[90px]" id="work"><ExploreWork /></section>
      <section className="scroll-mt-[120px]" id="map"><MapView /></section>
      <section className="scroll-mt-[50px]" id="contact"><ContactUs /></section>
    </div>
  );
}

export default App;
